<script setup lang="ts">
import { pascalCase } from 'scule';

const { clearBreadcrumbs } = useBreadcrumbs();
const { refreshSessionContext } = useSessionContext();
const { sanitizeRoutePath } = useCountrySwitch();
const { resolvePath } = useNavigationSearch();
const route = useRoute();
const { t } = useI18n();
const { url } = useCountrySwitch();
await refreshSessionContext();

const routePath = sanitizeRoutePath(route.path);
const country = useState('country');

const { data: seoResult } = await useAsyncData(
    `seoPath-${country.value}-${routePath.replaceAll('/', '')}`,
    async () => {
        // For client links if the history state contains seo url information we can omit the api call

        if (import.meta.client) {
            if (history.state?.routeName) {
                return {
                    routeName: history.state?.routeName,
                    foreignKey: history.state?.foreignKey,
                };
            }
        }

        return await resolvePath(routePath);
    },
);

const { routeName, foreignKey } = useNavigationContext(seoResult);
const { componentExists } = useCmsUtils();

if (!routeName.value) {
    throw createError({ statusCode: 404, message: t('error.404.detail'), fatal: true });
}

if(routePath === seoResult.value.pathInfo) {
    const seoPathInfo = seoResult.value.seoPathInfo || routePath;
    if (seoPathInfo !== routePath) {
        const newPath = url(`/${seoPathInfo}`);
        useRouter().replace(newPath, { query: route.query });
    }
} else if(seoResult.value?.seoPathInfo &&  routePath !== `/${seoResult.value.seoPathInfo}`) {
    const newPath = url(`/${seoResult.value.seoPathInfo}`);
    await navigateTo(newPath, { redirectCode: 301, replace: true });
}

onBeforeRouteLeave(() => {
    clearBreadcrumbs();
});
</script>

<template>
    <component
        :is="pascalCase(routeName)"
        v-if="componentExists(pascalCase(routeName))"
        :navigation-id="foreignKey"
    />
</template>
